import { useEffect } from 'react'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Avatar, Box, Drawer, Grid2, IconButton, Typography } from '@mui/material'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Constants, Grid_Gap } from '../../shared/constants'
import useTabs from '../../shared/hook/useTabs'
import TabPanel from '../../shared/components/Tabs/TabPanel'
import TabsComponent from '../../shared/components/Tabs/TabComponent'
import TransactionCom from '../../shared/components/student/TransactionCom'
import { ScrollContainerWithHeader } from '../../shared/components/student/ScrollComponent'
import useAuthStore from '../../store/useAuthStore'
import useDrawer from '../../shared/hook/useDrawer'
import ApartmentForm from './ApartmentForm'
import { useApartmentCourses, useApartmentDetails, useApartmentPayout, useStudentCourseCount } from '../../assets/api/useApartmentApi'
import { StudentCount } from '../../shared/components/apartment/StudentCount'
import { SkeletonCom, TextSkeleton } from '../../shared/utils/SkeletonCom'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { Icon } from '@iconify/react/dist/iconify.js'
import { CustomBadge } from '../../shared/utils/Badge'
import { AvatarCollabs } from '../../shared/utils/AvatarCollabs'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { GridChildren } from '../../shared/utils/LingtBlueContainer'
import ApartCourseCard from '../../shared/components/trainer.js/ApartCourseCard'
import { useLocation, useNavigate } from 'react-router-dom'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { useDialog } from '../../shared/hook/useDialog'
import { TermAndConditionList } from '../../assets/api/useMarketingExecutive'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import PayoutTable from '../commonfile/PayoutTable'
import MarketingTable from '../commonfile/MarketingTable'
import CommonTermAndConditionTable from '../commonfile/CommonTermAndConditionTable'
import api from '../../assets/nodeApi/axiosInstance'

const ApartmentDashbaord = () => {
  const { user, token } = useAuthStore();
  const { open, toggleDrawer } = useDrawer();
  const { value: reportValue, handleChange: reportHandleChange } = useTabs(0);
  const { value, handleChange } = useTabs(0);
  const { showToaster } = useToaster();
  const queryClient = useQueryClient();
  const { data: studentCourseCount, isLoading: isStudentCourseCountLoading } = useStudentCourseCount({ apartment_id: user?.apartment_id })
  const { data: termConditionList, isLoading: isTermConditionLaoding } = TermAndConditionList({ apartment_id: user?.apartment_id })
  const { data: CourseList, isLoading: isCourseListLoading } = useApartmentCourses(user?.apartment_id)
  const { data: payoutList, isLoading: isPayoutLoading } = useApartmentPayout()
  const { data: apartmentDetails, isLoading: isApartmentDetailsLoading } = useApartmentDetails({ apartment_name: user?.organization_name })
  const totalActiveStudent = studentCourseCount?.data?.reduce((acc, curr) => acc + Number(curr?.student_count), 0)
  const Reporttabs = [
    {
      label: "All", component: <>
        {
          !isPayoutLoading && < StudentCount count={totalActiveStudent} isLoading={isStudentCourseCountLoading} text={"All Subscriptions"} />
        }
        {
          isPayoutLoading && <SkeletonCom height={200} />
        }
      </>


    },
    {
      label: "Active", component: <>

        <ScrollContainerWithHeader boxShadow={"none"} customPadding={"none"}>

          {
            studentCourseCount?.data?.map((item, index) => (

              <Grid2 key={index} children size={{ xs: 12, sm: 6 }} sx={{ flex: '0 0 auto', borderLeft: index !== 0 ? "2px solid #B3C6FF" : "none", px: 1.5, minWidth: { xs: "230px", sm: "270px" } }}>
                <Box sx={{ display: "flex", mb: 3, justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant='body1' sx={{ fontWeight: 600 }}>Active Subscriptions</Typography>
                  <CustomBadge icon={<PeopleOutlineIcon />} />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant='h6' color='blue.main' sx={{ whiteSpace: "normal", wordBreak: "break-word"}}>{item?.course_title}</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                      <Typography variant='h3'>{item?.student_count}</Typography>
                      <AvatarCollabs />
                    </Box>
                  </Box>
                  <CustomBadge bgcolor={"#E2FFDD"} icon={<TrendingUpIcon sx={{ color: "#00BF59" }} />} />
                </Box>
              </Grid2>
            ))
          }
        </ScrollContainerWithHeader>
      </>
    }
  ];
  const tabsData = [
    {
      label: "All", component:
        <>
          {payoutList?.data?.map((item, index) => (
            <>
              <TransactionCom key={index} item={item} />
              {index !== payoutList?.data?.length - 1 && (
                <CustomDivider size={"0px"} sx={{ borderBottom: "1px solid #E8E8E8" }} />
              )}
            </>

          ))}
        </>
    },
    {
      label: "Courses", component: <>

        {payoutList?.data?.map((item, index) => (
          <>
            <TransactionCom key={index} item={item} />
            {index !== payoutList?.data?.length - 1 && (
              <CustomDivider size={"0px"} sx={{ borderBottom: "1px solid #E8E8E8" }} />
            )}
          </>

        ))}
      </>


    },
    { label: "Events", component: <></> },
  ];
  const { open: opentermCondtion, handleClickOpen, handleClose } = useDialog();

  const location = useLocation();

  useEffect(() => {
    if (!isTermConditionLaoding && termConditionList) {
      const terms = termConditionList?.terms_history || [];


      const hasPending = terms.some(item => item.status === 1);

      if (hasPending) {
        handleClickOpen();
      }
    }
  }, [isTermConditionLaoding, termConditionList]);

  const navigate = useNavigate();
  const handleDialogClose = () => {
    handleClose();
    const params = new URLSearchParams(location.search);
    params.delete("showPopup");
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const mutation = useMutation({
    mutationFn: (formData) => api.patch("apartment-terms/status", formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  });


  return (
    <Box>
      <CustomDivider />
      <Box
        sx={{
          height: { lg: '150px', xs: "auto" },
          background: `url(${Constants.customImages.ApartmentBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          flexDirection: "column",
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: "15px",
          py: 5
        }}
      >
        <IconButton onClick={() => toggleDrawer(true)}>
          <Avatar src={Constants.customImages.EventAvatar} alt='tranner avatar' sx={{ width: "70px", height: "70px" }} />
        </IconButton>
        <Typography color='#fff' variant='body2' mb={1} sx={{ textTransform: "capitalize" }}>{user?.firstname}{" "}{user?.lastname}</Typography>
        <Box sx={{ display: "flex", gap: 3 }}>
          {
            [`Total Flat: ${apartmentDetails?.data?.no_of_flats}`, `Apartment : ${user?.organization_name}`, `${apartmentDetails?.data?.address}`].map((item, index) => (
              <Typography color='#fff' variant='body2'>{item}</Typography>
            ))
          }
        </Box>
      </Box>
      <CustomDivider />
      <Grid2 container spacing={Grid_Gap}>
        <Grid2 children size={{ xs: 12, sm: 6 }}>
          <NormalContainerWithHeader headerText={"Report"} isGrid={false}>
            <TabsComponent tabs={Reporttabs} value={reportValue} onChange={reportHandleChange} />
            {Reporttabs.map((tab, index) => (
              <TabPanel key={index} value={reportValue} index={index}>
                {tab.component}
              </TabPanel>
            ))}
          </NormalContainerWithHeader>
        </Grid2>
        <Grid2 children size={{ xs: 12, sm: 6 }}>
          <NormalContainerWithHeader headerText={"Earnings Breakdown"} isGrid={false} RightContent={<Typography variant='body2' color='blue.main' sx={{ display: 'flex', alignItems: "center" }}> <Icon icon="solar:wallet-money-outline" width={20} />      <CurrencyRupeeIcon fontSize="20px" />     {value !== 2 ? payoutList?.apartment_total_amount : 0}</Typography>}>
            <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
            {tabsData.map((tab, index) => (
              <TabPanel key={index} value={value} index={index}>
                {tab.component}
              </TabPanel>
            ))}
          </NormalContainerWithHeader>
        </Grid2>
      </Grid2>

      <CustomDivider />
      <ScrollContainerWithHeader headerText={"Apartment Courses"}>
        {
          !isCourseListLoading && CourseList?.data?.map((item, index) => (
            <GridChildren index={index} key={index} sx={{ flex: '0 0 auto' }} >
              <ApartCourseCard item={item} />
            </GridChildren>
          ))
        }
        {
          isCourseListLoading && [...Array(3)].map((_, index) => (
            <GridChildren index={index} key={index} sx={{ flex: '0 0 auto' }} >
              <SkeletonCom />
            </GridChildren>
          ))
        }
      </ScrollContainerWithHeader>

      <Drawer anchor="right" open={open} onClose={() => toggleDrawer(false)}>
        <Box sx={{ width: { lg: "40vw", xs: "100%" } }}>
          <ApartmentForm onClose={() => toggleDrawer(false)} />
        </Box>
      </Drawer>
      <MainDialogBox open={opentermCondtion} handleClose={handleClose} width={"50%"}>
        {isTermConditionLaoding ? <TextSkeleton line={5} /> :
          <>



            {termConditionList?.terms_history && termConditionList?.terms_history?.length !== 0 &&
              <>
                <Typography variant='h5' mb={1}>Term History</Typography>
                <CommonTermAndConditionTable id={user?.apartment_id} />

                <CustomDivider />
              </>
            }
            <CustomDivider />
            {termConditionList?.student_payouts && termConditionList?.student_payouts?.length !== 0 &&
              <>
                <Typography variant='h5' mb={1}>Payouts</Typography>
                <PayoutTable id={user?.apartment_id} />

                <CustomDivider />
              </>
            }

            {termConditionList?.marketing_ads && termConditionList?.marketing_ads?.length !== 0 &&
              <>
                <Typography variant='h5' mb={1}> Marketing Ads </Typography>
                <MarketingTable id={user?.apartment_id} />
                <CustomDivider />
              </>

            }
          </>


        }




      </MainDialogBox>
    </Box>
  )
}

export default ApartmentDashbaord